import React from 'react';
import { Redirect } from 'react-router';
import { CpPreviewRoute } from 'components/organisms/customer-portal/builder-components/tabs/design-tab/cp-preview-route';
import { CpPreviewWithoutProject } from 'components/organisms/customer-portal/builder-components/tabs/design-tab/cp-preview-without-project';
import { CpFilesPreviewPage } from 'components/organisms/customer-portal/widgets/all-files/cp-files-preview-page';
import { CpSpaceTabPage } from 'components/organisms/customer-portal/widgets/space/cp-space-tab-page';
import { RoutePaths } from 'constant';
import { CustomSecureRoute } from 'routes/custom-secure-route';
import '../../tailwind.css';
import '../../index.css';

const RouteWithProjectId: React.FC<{
  setProjectId: (projectId: string) => void;
}> = () => {
  return <CpPreviewRoute />;
};

export const PortalBotRoutes = () => {
  const [projectId, setProjectId] = React.useState<string | null>(null);

  return (
    <>
      <CustomSecureRoute
        path={RoutePaths.liveCustomerPortal}
        strict
        component={() => {
          return <RouteWithProjectId setProjectId={setProjectId} />;
        }}
      />
      <CustomSecureRoute
        path={RoutePaths.liveCustomerPortalWithoutProject}
        strict
        component={CpPreviewWithoutProject}
      />
      <CustomSecureRoute
        path={RoutePaths.home}
        strict
        component={() => {
          if (projectId) {
            return <CpPreviewRoute />;
          }

          return <Redirect to={RoutePaths.liveCustomerPortalWithoutProject} />;
        }}
      />

      <CustomSecureRoute path={RoutePaths.customerPortalAttachmentById} exact>
        <CpFilesPreviewPage />
      </CustomSecureRoute>

      <CustomSecureRoute path={RoutePaths.customerPortalSpaceTabById} exact>
        <CpSpaceTabPage />
      </CustomSecureRoute>
    </>
  );
};
